const APP_CONSTANTS = {
        NOT_STARTED: 'NOT_STARTED',
        CONFIRMED: 'CONFIRMED',
        IN_PROGRESS: 'IN_PROGRESS',
        REVOKED: 'REVOKED',
        CHARITY_MCC_CODE: 8398,
        CDD_POLICY: 'CDD',
        CRA: 'CHARITY_REG_REVENUE_AGENCY'
    },
    TECHSOUP_SUPPORTED_COUNTRIES = ['CA', 'BR', 'MX'],
    CDD_ONLY_SHARECONSENT = ['BR', 'MX'],
    ALLOWED_UK_BUSINESS_TYPE = ['CORPORATION', 'PRIVATE_CORPORATION', 'NONPROFIT', 'GOVERNMENT'],
    ALLOWED_IE_BUSINESS_TYPE = ['NONPROFIT'];

module.exports = {
    ALLOWED_UK_BUSINESS_TYPE: ALLOWED_UK_BUSINESS_TYPE,
    ALLOWED_IE_BUSINESS_TYPE: ALLOWED_IE_BUSINESS_TYPE,
    TECHSOUP_SUPPORTED_COUNTRIES: TECHSOUP_SUPPORTED_COUNTRIES,
    CDD_ONLY_SHARECONSENT: CDD_ONLY_SHARECONSENT,
    APP_CONSTANTS: APP_CONSTANTS
};
